module.exports = __webpack_public_path__ + "media/images/WFC_Portrait_White-8310a797246243e787efff3ee1f3d1e9.svg";